module.exports = __webpack_public_path__ + "img/icon_saved.99c1b79f.svg";